import { defineComponent, Ref, ref, onMounted, onBeforeUnmount, computed, nextTick, watch, onUnmounted } from 'vue';
import { Constants } from '@truckdown/systems';
import context from '@truckdown/components-systems';

interface IProps {
}

interface IData {
    showForm: Ref<boolean>
}

const getData = function (props: IProps) {
    return {
        showForm: ref<boolean>(false)
    } as IData;
}

const isActivated = function () {
    return context.hasClaim('FSRACTIVATED', 'True');
}

const canRegister = function () {
    return context.isAuthenticated
        && context.isInRole(Constants.Roles.CustomerAdminRole);
}

const getComputed = function (props: IProps, data: IData) {
    return {
        showLogin: computed(() => {
            return !context.isAuthenticated;
        }),
        showRegister: computed(() => {
            return !isActivated() && canRegister();
        }),
        showSearch: computed(() => {
            return context.isAuthenticated && (isActivated() || !canRegister());
        })
    }
}

const getMethods = function (data: IData) {
    return {
        openForm: function () {
            data.showForm.value = true;
        },
        closeForm: function () {
            data.showForm.value = false;
        }
    };
}

export default defineComponent({
    props: {
    },
    setup: function (props, ctx) {
        let data = getData(props);
        let computed = getComputed(props, data);
        let methods = getMethods(data);

        return {
            ...data,
            ...computed,
            ...methods
        };
    }
});